/* eslint-disable */
export default {
  account: 'Compte',
  contact: 'Contact',
  lead: 'Piste',
  opportunity: 'Occasion',
  case: 'Dossier',
  chooseEntity: 'Choisir type d’entité',
  create: 'Créer',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
